/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.




import * as BasicContentAccordion from 'src/components/BasicContent/BasicContentAccordion';
import * as BasicContentAccordionItem from 'src/components/BasicContent/BasicContentAccordionItem';
import * as BasicContentAttachment from 'src/components/BasicContent/BasicContentAttachment';
import * as BasicContentAttachments from 'src/components/BasicContent/BasicContentAttachments';
import * as BasicContentBackToTopButton from 'src/components/BasicContent/BasicContentBackToTopButton';
import * as BasicContentComplexStat from 'src/components/BasicContent/BasicContentComplexStat';
import * as BasicContentComplexStatStack from 'src/components/BasicContent/BasicContentComplexStatStack';
import * as BasicContentCTABanner from 'src/components/BasicContent/BasicContentCTABanner';
import * as BasicContentCTAButton from 'src/components/BasicContent/BasicContentCTAButton';
import * as BasicContentErrorPageHeader from 'src/components/BasicContent/BasicContentErrorPageHeader';
import * as BasicContentFirmFeature from 'src/components/BasicContent/BasicContentFirmFeature';
import * as BasicContentFullWidthEmbed from 'src/components/BasicContent/BasicContentFullWidthEmbed';
import * as BasicContentFullWidthImage from 'src/components/BasicContent/BasicContentFullWidthImage';
import * as BasicContentHeadlineAndAbstract from 'src/components/BasicContent/BasicContentHeadlineAndAbstract';
import * as BasicContentHighlights from 'src/components/BasicContent/BasicContentHighlights';
import * as BasicContentHorizontalImageSplitHero from 'src/components/BasicContent/BasicContentHorizontalImageSplitHero';
import * as BasicContentHorizontalTiles from 'src/components/BasicContent/BasicContentHorizontalTiles';
import * as BasicContentIconCard from 'src/components/BasicContent/BasicContentIconCard';
import * as BasicContentIconCards from 'src/components/BasicContent/BasicContentIconCards';
import * as BasicContentImage from 'src/components/BasicContent/BasicContentImage';
import * as BasicContentInfographic from 'src/components/BasicContent/BasicContentInfographic';
import * as BasicContentInteractiveMap from 'src/components/BasicContent/BasicContentInteractiveMap';
import * as BasicContentMediaGrid from 'src/components/BasicContent/BasicContentMediaGrid';
import * as BasicContentMediaGridItem from 'src/components/BasicContent/BasicContentMediaGridItem';
import * as BasicContentPullQuote from 'src/components/BasicContent/BasicContentPullQuote';
import * as BasicContentRichText from 'src/components/BasicContent/BasicContentRichText';
import * as BasicContentShareTray from 'src/components/BasicContent/BasicContentShareTray';
import * as BasicContentSimpleStat from 'src/components/BasicContent/BasicContentSimpleStat';
import * as BasicContentSimpleStatStack from 'src/components/BasicContent/BasicContentSimpleStatStack';
import * as BasicContentTabItem from 'src/components/BasicContent/BasicContentTabItem';
import * as TabItem from 'src/components/BasicContent/BasicContentTabItem/TabItem';
import * as BasicContentTabs from 'src/components/BasicContent/BasicContentTabs';
import * as BasicContentTextCardItem from 'src/components/BasicContent/BasicContentTextCardItem';
import * as BasicContentTextCards from 'src/components/BasicContent/BasicContentTextCards';
import * as BasicContentTile from 'src/components/BasicContent/BasicContentTile';
import * as BasicContentVerticalTiles from 'src/components/BasicContent/BasicContentVerticalTiles';
import * as BasicContentVideo from 'src/components/BasicContent/BasicContentVideo';
import * as BasicContentVideoWithBanner from 'src/components/BasicContent/BasicContentVideoWithBanner';
import * as InsightsAgenda from 'src/components/Insights/InsightsAgenda';
import * as InsightsAgendaItem from 'src/components/Insights/InsightsAgendaItem';
import * as InsightsClientStoriesCarousel from 'src/components/Insights/InsightsClientStoriesCarousel';
import * as InsightsFeaturedCard from 'src/components/Insights/InsightsFeaturedCard';
import * as InsightsFlexibleFeatureItem from 'src/components/Insights/InsightsFlexibleFeatureItem';
import * as InsightsFlexibleFeatures from 'src/components/Insights/InsightsFlexibleFeatures';
import * as InsightsHorizontalImageSplitHero from 'src/components/Insights/InsightsHorizontalImageSplitHero';
import * as InsightsInsightHeader from 'src/components/Insights/InsightsInsightHeader';
import * as InsightsInsightLandingHeader from 'src/components/Insights/InsightsInsightLandingHeader';
import * as InsightsLatestInsights from 'src/components/Insights/InsightsLatestInsights';
import * as InsightsNewsSearch from 'src/components/Insights/InsightsNewsSearch';
import * as InsightsPeopleRelatedContent from 'src/components/Insights/InsightsPeopleRelatedContent';
import * as InsightsRelatedContent from 'src/components/Insights/InsightsRelatedContent';
import * as InsightsResourceCards from 'src/components/Insights/InsightsResourceCards';
import * as InsightsSearch from 'src/components/Insights/InsightsSearch';
import * as InsightsTopicFilterInsights from 'src/components/Insights/InsightsTopicFilterInsights';
import * as InsightsTopicsContent from 'src/components/Insights/InsightsTopicsContent';
import * as ResourceCard from 'src/components/Insights/ResourceCard';
import * as MetadataMetadata from 'src/components/MetadataMetadata';
import * as NavigationBreadcrumbs from 'src/components/Navigation/NavigationBreadcrumbs';
import * as NavigationFooter from 'src/components/Navigation/NavigationFooter';
import * as NavigationHeader from 'src/components/Navigation/NavigationHeader';
import * as InsightsPanel from 'src/components/Navigation/NavigationHeader/components/InsightsPanel';
import * as LocaleDropdown from 'src/components/Navigation/NavigationHeader/components/LocaleDropdown';
import * as MobileMenu from 'src/components/Navigation/NavigationHeader/components/MobileMenu';
import * as ToggleMobileMenu from 'src/components/Navigation/NavigationHeader/components/MobileMenu/ToggleMobileMenu';
import * as NavPanel from 'src/components/Navigation/NavigationHeader/components/NavPanel';
import * as SearchDropdown from 'src/components/Navigation/NavigationHeader/components/SearchDropdown';
import * as SiteSearchBox from 'src/components/Navigation/NavigationHeader/components/SearchDropdown/SiteSearchBox';
import * as ToggleSearchDropdown from 'src/components/Navigation/NavigationHeader/components/SearchDropdown/ToggleSearchDropdown';
import * as Address from 'src/components/Offices/Address';
import * as JobResults from 'src/components/Offices/JobResults';
import * as OfficeJobDetailHeader from 'src/components/Offices/OfficeJobDetailHeader';
import * as OfficeLandingHeader from 'src/components/Offices/OfficeLandingHeader';
import * as OfficeLandingListing from 'src/components/Offices/OfficeLandingListing';
import * as LocationCard from 'src/components/Offices/OfficeLandingListing/LocationCard';
import * as OfficeOfficeHeader from 'src/components/Offices/OfficeOfficeHeader';
import * as OfficesJobSearch from 'src/components/Offices/OfficesJobSearch';
import * as OfficesRelatedJobs from 'src/components/Offices/OfficesRelatedJobs';
import * as PeopleAdmissions from 'src/components/People/PeopleAdmissions';
import * as PeopleAuthors from 'src/components/People/PeopleAuthors';
import * as PeopleContacts from 'src/components/People/PeopleContacts';
import * as PeopleDetailHeroLeft from 'src/components/People/PeopleDetailHeroLeft';
import * as PeopleEducation from 'src/components/People/PeopleEducation';
import * as PeopleEducationItem from 'src/components/People/PeopleEducationItem';
import * as PeopleLanguages from 'src/components/People/PeopleLanguages';
import * as PeopleProfessionalHeader from 'src/components/People/PeopleProfessionalHeader';
import * as PeopleSearch from 'src/components/People/PeopleSearch';
import * as PeopleSocialMediaIcon from 'src/components/People/PeopleSocialMediaIcon';
import * as PeopleSpeakers from 'src/components/People/PeopleSpeakers';
import * as RobotsMetadata from 'src/components/RobotsMetadata';
import * as SearchSearch from 'src/components/Search/SearchSearch';
import * as ServiceList from 'src/components/Services/ServiceList';
import * as ServicesFeaturedServices from 'src/components/Services/ServicesFeaturedServices';
import * as ServicesLetterFilter from 'src/components/Services/ServicesLetterFilter';
import * as ServicesRegionalCapabilities from 'src/components/Services/ServicesRegionalCapabilities';
import * as ServicesRelated from 'src/components/Services/ServicesRelated';
import * as ServicesRelatedList from 'src/components/Services/ServicesRelated/ServicesRelatedList';
import * as ServicesSearchBar from 'src/components/Services/ServicesSearchBar';
import * as ServicesServiceHeader from 'src/components/Services/ServicesServiceHeader';
import * as ServicesServiceList from 'src/components/Services/ServicesServiceList';

const components = new Map();

components.set('BasicContentAccordion', BasicContentAccordion);
components.set('BasicContentAccordionItem', BasicContentAccordionItem);
components.set('BasicContentAttachment', BasicContentAttachment);
components.set('BasicContentAttachments', BasicContentAttachments);
components.set('BasicContentBackToTopButton', BasicContentBackToTopButton);
components.set('BasicContentComplexStat', BasicContentComplexStat);
components.set('BasicContentComplexStatStack', BasicContentComplexStatStack);
components.set('BasicContentCTABanner', BasicContentCTABanner);
components.set('BasicContentCTAButton', BasicContentCTAButton);
components.set('BasicContentErrorPageHeader', BasicContentErrorPageHeader);
components.set('BasicContentFirmFeature', BasicContentFirmFeature);
components.set('BasicContentFullWidthEmbed', BasicContentFullWidthEmbed);
components.set('BasicContentFullWidthImage', BasicContentFullWidthImage);
components.set('BasicContentHeadlineAndAbstract', BasicContentHeadlineAndAbstract);
components.set('BasicContentHighlights', BasicContentHighlights);
components.set('BasicContentHorizontalImageSplitHero', BasicContentHorizontalImageSplitHero);
components.set('BasicContentHorizontalTiles', BasicContentHorizontalTiles);
components.set('BasicContentIconCard', BasicContentIconCard);
components.set('BasicContentIconCards', BasicContentIconCards);
components.set('BasicContentImage', BasicContentImage);
components.set('BasicContentInfographic', BasicContentInfographic);
components.set('BasicContentInteractiveMap', BasicContentInteractiveMap);
components.set('BasicContentMediaGrid', BasicContentMediaGrid);
components.set('BasicContentMediaGridItem', BasicContentMediaGridItem);
components.set('BasicContentPullQuote', BasicContentPullQuote);
components.set('BasicContentRichText', BasicContentRichText);
components.set('BasicContentShareTray', BasicContentShareTray);
components.set('BasicContentSimpleStat', BasicContentSimpleStat);
components.set('BasicContentSimpleStatStack', BasicContentSimpleStatStack);
components.set('BasicContentTabItem', BasicContentTabItem);
components.set('TabItem', TabItem);
components.set('BasicContentTabs', BasicContentTabs);
components.set('BasicContentTextCardItem', BasicContentTextCardItem);
components.set('BasicContentTextCards', BasicContentTextCards);
components.set('BasicContentTile', BasicContentTile);
components.set('BasicContentVerticalTiles', BasicContentVerticalTiles);
components.set('BasicContentVideo', BasicContentVideo);
components.set('BasicContentVideoWithBanner', BasicContentVideoWithBanner);
components.set('InsightsAgenda', InsightsAgenda);
components.set('InsightsAgendaItem', InsightsAgendaItem);
components.set('InsightsClientStoriesCarousel', InsightsClientStoriesCarousel);
components.set('InsightsFeaturedCard', InsightsFeaturedCard);
components.set('InsightsFlexibleFeatureItem', InsightsFlexibleFeatureItem);
components.set('InsightsFlexibleFeatures', InsightsFlexibleFeatures);
components.set('InsightsHorizontalImageSplitHero', InsightsHorizontalImageSplitHero);
components.set('InsightsInsightHeader', InsightsInsightHeader);
components.set('InsightsInsightLandingHeader', InsightsInsightLandingHeader);
components.set('InsightsLatestInsights', InsightsLatestInsights);
components.set('InsightsNewsSearch', InsightsNewsSearch);
components.set('InsightsPeopleRelatedContent', InsightsPeopleRelatedContent);
components.set('InsightsRelatedContent', InsightsRelatedContent);
components.set('InsightsResourceCards', InsightsResourceCards);
components.set('InsightsSearch', InsightsSearch);
components.set('InsightsTopicFilterInsights', InsightsTopicFilterInsights);
components.set('InsightsTopicsContent', InsightsTopicsContent);
components.set('ResourceCard', ResourceCard);
components.set('MetadataMetadata', MetadataMetadata);
components.set('NavigationBreadcrumbs', NavigationBreadcrumbs);
components.set('NavigationFooter', NavigationFooter);
components.set('NavigationHeader', NavigationHeader);
components.set('InsightsPanel', InsightsPanel);
components.set('LocaleDropdown', LocaleDropdown);
components.set('MobileMenu', MobileMenu);
components.set('ToggleMobileMenu', ToggleMobileMenu);
components.set('NavPanel', NavPanel);
components.set('SearchDropdown', SearchDropdown);
components.set('SiteSearchBox', SiteSearchBox);
components.set('ToggleSearchDropdown', ToggleSearchDropdown);
components.set('Address', Address);
components.set('JobResults', JobResults);
components.set('OfficeJobDetailHeader', OfficeJobDetailHeader);
components.set('OfficeLandingHeader', OfficeLandingHeader);
components.set('OfficeLandingListing', OfficeLandingListing);
components.set('LocationCard', LocationCard);
components.set('OfficeOfficeHeader', OfficeOfficeHeader);
components.set('OfficesJobSearch', OfficesJobSearch);
components.set('OfficesRelatedJobs', OfficesRelatedJobs);
components.set('PeopleAdmissions', PeopleAdmissions);
components.set('PeopleAuthors', PeopleAuthors);
components.set('PeopleContacts', PeopleContacts);
components.set('PeopleDetailHeroLeft', PeopleDetailHeroLeft);
components.set('PeopleEducation', PeopleEducation);
components.set('PeopleEducationItem', PeopleEducationItem);
components.set('PeopleLanguages', PeopleLanguages);
components.set('PeopleProfessionalHeader', PeopleProfessionalHeader);
components.set('PeopleSearch', PeopleSearch);
components.set('PeopleSocialMediaIcon', PeopleSocialMediaIcon);
components.set('PeopleSpeakers', PeopleSpeakers);
components.set('RobotsMetadata', RobotsMetadata);
components.set('SearchSearch', SearchSearch);
components.set('ServiceList', ServiceList);
components.set('ServicesFeaturedServices', ServicesFeaturedServices);
components.set('ServicesLetterFilter', ServicesLetterFilter);
components.set('ServicesRegionalCapabilities', ServicesRegionalCapabilities);
components.set('ServicesRelated', ServicesRelated);
components.set('ServicesRelatedList', ServicesRelatedList);
components.set('ServicesSearchBar', ServicesSearchBar);
components.set('ServicesServiceHeader', ServicesServiceHeader);
components.set('ServicesServiceList', ServicesServiceList);

// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// componentModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// componentFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.
// Editing mode doesn't work well with dynamic components in nextjs: dynamic components are not displayed without refresh after a rendering is added. 
// This happens beacuse Sitecore editors simply insert updated HTML generated on server side. This conflicts with nextjs dynamic logic as no HTML gets rendered for dynamic component
// So we use require() to obtain dynamic components in editing mode while preserving dynamic logic for non-editing scenarios
// As we need to be able to seamlessly work with dynamic components in both editing and normal modes, different componentFactory functions will be passed to app

export function componentModule(componentName: string) {
  const component = components.get(componentName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}

function baseComponentFactory(componentName: string, exportName?: string, isEditing?: boolean) {
  const DEFAULT_EXPORT_NAME = 'Default';
  const component = components.get(componentName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element(isEditing);
  }

  if (exportName && exportName !== DEFAULT_EXPORT_NAME) {
    return component[exportName];
  }

  return component?.Default || component?.default || component;
}
  
export function componentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, false);
}

export function editingComponentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, true);
}
